define('casino/ingame',['jquery', 'all/navigation', 'all/dialog', 'all/slidingContentWrapper', 'all/player/session', 'casino/casino', 'casino/instantdeposit', 'casino/game-mode', 'casino/activity-feed', 'casino/tournaments', 'casino/game-resize', 'casino/game', 'casino/allgames'],
	function ($, navigation, dialog, slidingContentWrapper, session, casino, instantDeposit, gameMode, activity, tournaments, gameResize, game, allgames) {
		'use strict';

		var NETENT = 3;

		var ingame = {};
		var firstTimeEnteringIngame = true;

		ingame.show = function showIngame() {
			doAlwaysOnIngameShow();

			if ($('#casino-ingame').is(':visible')) {
				return;
			}
			doDocumentUnSelect();
			doOnceOnIngameShow();
		};

		ingame.hide = function hideIngame() {
			$('#casino-ingame').hide();
            removeGameBackground();
			unloadGames();
		};

        function removeGameBackground() {
            var $mainContentWrapper = $('#main-content-wrapper');
            $mainContentWrapper.removeClass('bg-ingame');
            $mainContentWrapper.css('background-image', '');
        }

		function doDocumentUnSelect() {
			var selection = ('getSelection' in window) ? window.getSelection() : ('selection' in document) ? document.selection : null;
			console.log(selection);
			if ('empty' in selection) {
				selection.empty();
			}
			else if ('removeAllRanges' in selection) {
				setTimeout(function () {
					if (!isInheritSelection(selection.focusNode)) {
						selection.removeAllRanges();
					}
				}, 0);
			}

		}

		function isInheritSelection(selection) {
			if (selection) {
				if (selection.contentEditable) {
					if (selection.contentEditable === 'inherit') {
						return true;
					}
				}
				if (selection.parentNode) {
					return isInheritSelection(selection.parentNode);
				}
			}
			return false;
		}

		function doAlwaysOnIngameShow() {
			var $casinoIngame = $('#casino-ingame');
			$casinoIngame.find('.game-group').hide();
			gameResize.setSelectedGameSizeButton();
		}

		function onLogout() {
			$('#money-mode').find('a.fun-mode').click();
			instantDeposit.setInstantDepositModeInvisible();
		}

		function onLogin() {
			$('#money-mode').find('a.real-mode').click();
			if (session.authenticated) {
				instantDeposit.instantDepositInit();
			}
		}

		function setupLoginRegisterLinks() {
			var $casinoIngame = $('#casino-ingame');
			$casinoIngame.find('.player-bar a.login').off().click(function () {
				slidingContentWrapper.showSlidingLoginPopup();
			});
			$casinoIngame.find('.player-bar a.registration').off('click').on('click', function(){
                slidingContentWrapper.showSlidingSignup();
            });
		}

		function doOnceOnIngameShow() {
			saveLastTabAndPosition();

			if (firstTimeEnteringIngame) {
				$(session).on('login', onLogin);
				$(session).on('logout', onLogout);
				firstTimeEnteringIngame = false;
			}
			session.showHideStandardClasses();

			activity.changeWinnersFeedToMinimizedWidth();

			if (session.authenticated) {
				instantDeposit.instantDepositInit();
			}

			gameResize.init();

			setupLoginRegisterLinks();
			$('#casino-ingame').show();
		}

		function saveLastTabAndPosition() {
			// TODO: javascript - move this to save on exit in lobby
			if (casino.lastSelectedLobbyTab) {
				casino.lastLobbyScrollPosition = $(window).scrollTop();
			} else {
				casino.lastSelectedLobbyTab = findFirstLobbyTab();
				casino.lastLobbyScrollPosition = 0;
			}

			$('#back-to-lobby').find('a').attr('href', casino.lastSelectedLobbyTab);
		}

		function findFirstLobbyTab() {
			return $('#casino-top-menu').find('li:first a').attr('href');
		}

		function populateChangeGameSelects(gameIds) {
			var $select = $('#casino-ingame').find('.change-game select');
			$select.empty();

			$('#filter-categories').find('li:not(.exclude-dropdown)').each(function () {
				var $li = $(this);
				var category = $li.find('a').text();

                var gamesArray = $li.data('games');

                if($.isArray(gamesArray) === false) {
                    return;
                }

				var allGames = casino.getGames(gamesArray);
				allGames.sort(gameNameSorter);
				var onlyNetentGames = $.grep(allGames, onlyNetentGamesFilter);

				for (var current = 0; current < gameIds.length; current++) {
					var filteredGames = (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) ? allGames : onlyNetentGames;
					for (var other = 0; other < gameIds.length; other++) {
						if (other === current) {
							continue;
						}
						var alreadySelectedGameId = gameIds[other];
						filteredGames = removeGameWithId(filteredGames, alreadySelectedGameId);
					}
					$select.eq(current).append(createOptGroup(category, filteredGames));
				}
			});

			$select.on('change', function () {
				var $this = $(this);
				casino.replaceGameIdInLocationHash($this.parents('.game-holder').data('game.id'), $this.val());
			});
		}

		function onlyNetentGamesFilter(game) {
			return game.provider === NETENT;
		}

		function removeGameWithId(games, gameId) {
			return $.grep(games, function (game) {
				return 'game=' + game.id !== gameId;
			});
		}

		function gameNameSorter(game1, game2) {
			if (game1.name < game2.name) {
				return -1;
			}
			if (game2.name < game1.name) {
				return 1;
			}
			return 0;
		}

		function createOptGroup(category, games) {
			var $optgroup = $('<optgroup/>', {
				label: category
			});

			for (var i = 0; i < games.length; i++) {
				var game = games[i];
				var name = game.name;
				var value = $.isNumeric(game.id) ? 'game=' + game.id : game.id;
				var $option = $('<option/>', {
					value: value
				}).text(name);

				$option.appendTo($optgroup);
			}
			return $optgroup;
		}

		function unloadGames() {
			var $casinoIngame = $('#casino-ingame');
			$casinoIngame.find('.game-holder .game').empty();
			$casinoIngame.find('.game-holder').removeData('game.id');
		}

		function toggleQuickChange(gameIds) {
			var $quickChange = $('.game-holder .quick-change');
			var multiGame = gameIds.length > gameMode.MODE_ONE_GAME;
			if (multiGame) {
				$quickChange.hide();
			} else {
				$quickChange.show();
			}
		}

		function loadGames(gameIds) {
			//This closes the mini lobby on game page.
			$('#dialog-quickchange').bPopup().close();

			gameMode.updateGameModeButtons(gameIds);

			verifyNumberOfGameIdsOrThrow(gameIds);
			updateViewForGameMode(gameIds);
			populateChangeGameSelects(gameIds);
			toggleQuickChange(gameIds);

			if (sessionStorage.getItem('resizedGame') === 'true') {
				sessionStorage.setItem('resizedGame', false);
			}

			gameResize.resize();

			populateGames(gameIds);
			activity.moveToIngame();
			setBackground(gameIds);

			showHideBottomInfoBox(gameIds);
			updateIngameTournaments(gameIds);

		}

		function verifyNumberOfGameIdsOrThrow(gameIds) {
			switch (gameIds.length) {
				case 0:
					throw new Error('List of game ids is empty');
				case 1:
					break;
				case 2:
					break;
				case 3:
					throw new Error('Number of game ids can not be 3');
				case 4:
					break;
				default:
					throw new Error('Too many gameIds, > 4');
			}
		}

		function showHideBottomInfoBox(gameIds) {
			var $bottomInfoBox = $('#game-name-description').parent().parent();
			if (gameIds.length === 1) {
				$bottomInfoBox.show();
				populateRecommendedgames(gameIds);
			} else {
				$bottomInfoBox.hide();
			}
		}

		function populateRecommendedgames(gameIds) {
			$('#might-like-games').populate(casino.getRecommendedGameIds(gameIds));
		}

		function updateIngameTournaments(gameIds) {
			if (session.authenticated) {
				tournaments.toggleVisibleTournaments(gameIds);
			} else {
				tournaments.hideIngameTournaments();
			}
		}

		// TODO: this is only correct for TILED mode
		function updateViewForGameMode(gameIds) {
			var TILED = true;
			var $cnt = $('#casino-ingame').find('.cnt-ingame');

			if (gameIds.length > 1 && TILED) {
				$cnt.removeClass('full');
				$cnt.addClass('half');

				$cnt.find('.cnt-activity-feed').hide();
			}
			else {
				$cnt.removeClass('half');
				$cnt.addClass('full');

				$cnt.find('.cnt-activity-feed').addClass('expanded');
				$cnt.find('.cnt-activity-feed').show();
			}
		}

		function populateGames(gameIds) {
			$('#casino-ingame').find('.game-holder').each(function populateOneGame() {
				var $gh = $(this);
				var index = $gh.index('.game-holder');

				var emptyGameBox = index >= gameIds.length;
				if (emptyGameBox) {
					$gh.hide();
					$gh.find('.game').empty();
					$gh.removeData('game.id');
				} else {
					$gh.show();
					var gameId = gameIds[index];

					var $game = $gh.find('.game');
					var $group = $gh.find('.game-group');
					var $groupBackground = $gh.find('.background');
					if (gameId.indexOf('group') === 0) {
						$game.hide();
						$group.show();
						$groupBackground.css('display', 'inline-block');
					} else {
						$game.show();
						$group.hide();
						//$groupBackground.hide();
					}

					setSelectedGameInDropbox($gh, gameId);

					var alreadyLoaded = $gh.data('game.id') === gameId;
					if (!alreadyLoaded) {
						$gh.data('game.id', gameId);
						loadGame($gh, gameId);
					}
				}
			});
		}

		function loadGame($gh, gameId) {
			game.load($gh, gameId);
		}

		function setSelectedGameInDropbox($gh, gameId) {
			gameId = $.isNumeric(gameId) ? 'game=' + gameId : gameId;

			var groupKey = casino.getGroupKeyForGameId(gameId);

			if (groupKey) {
				gameId = groupKey;
			}

			var $select = $gh.find('.change-game select');
			$select.val(gameId);
		}

		function setBackground(gameIds) {
			if (gameIds.length === 1) {
				setGameBackGround(gameIds[0]);
			} else {
				createGameBackgroundImage(navigation.updatableImgURL('game-background-multiple.jpg'));
			}
		}

		function setGameBackGround(gameId) {
			if (gameId.slice(0, 5) === 'group') {
				gameId = Object.keys(casino.getGame(gameId).games)[0];
			}

			var game = casino.getGame(gameId);

			var backgroundMainClass = $('.bg-main');
			var bodyStyle = 'background-image: none;';
			if (game.backgroundColor) {
				bodyStyle += 'background-color:' + game.backgroundColor;
			}
			backgroundMainClass.attr('style', bodyStyle);

			var backgroundSrc;
			if (game.backgroundUrl) {
				backgroundSrc = navigation.dynamicURL(game.backgroundUrl);
			} else {
				backgroundSrc = navigation.updatableImgURL('game-background-single.jpg');
			}
			createGameBackgroundImage(backgroundSrc);
		}

		function createGameBackgroundImage(imageUrl) {
            var $mainContentWrapper = $('#main-content-wrapper');
            $mainContentWrapper.css('background-image',  'url("' + imageUrl + '")');
            $mainContentWrapper.addClass('bg-ingame');
		}

		ingame.loadGames = loadGames;

		ingame.switchToRealMode = function switchToRealMode() {
			ingame.selectRealModeButton();

			if (session.authenticated) {
				casino.mode = 'real';
				reloadGames();
			} else {
				slidingContentWrapper.showSlidingLoginPopup();
			}
		};

		ingame.selectRealModeButton = function () {
			var $realModeButton = $('.real-mode');
			if ($realModeButton.hasClass('active')) {
				return;
			}

			$realModeButton.addClass('active');
			$('.fun-mode').removeClass('active');
		};

		ingame.switchToFunMode = function switchToFunMode() {
			ingame.selectFunModeButton();

			casino.mode = 'free';
			reloadGames();
		};

		ingame.selectFunModeButton = function () {
			var $funModeButton = $('.fun-mode');
			if ($funModeButton.hasClass('active')) {
				return;
			}

			$funModeButton.addClass('active');
			$('.real-mode').removeClass('active');

		};

		function reloadGames() {
			$('.game-holder').each(function () {
				var $gh = $(this);
				var gameId = $gh.data('game.id');
				if (gameId) {
					game.load($gh, gameId);
				}
			});
		}

		$(function setupMoneyModeButtons() {
			var $moneyMode = $('#money-mode');
			$moneyMode.find('.fun-mode').click(ingame.switchToFunMode);
			$moneyMode.find('.real-mode').click(ingame.switchToRealMode);
		});

		return ingame;

	});

